import { Image } from 'antd';
import React from 'react';

interface Image {
  proc_img_indx: string;
  user_img_url: string;
  proc_id: number;
}
interface Prop {
  userImage: any;
  procId: number;
}
function ProcImageViewButton(props: Prop) {
  return (
    <Image.PreviewGroup>
      {props.userImage
        .filter((i: Image) => i.proc_id === props.procId)
        .map((i: Image) => (
          <Image
            src={i.user_img_url}
            width={120}
            height={80}
            style={{ objectFit: 'cover' }}
          />
        ))}
    </Image.PreviewGroup>
  );
}

export default ProcImageViewButton;
